module.exports = __webpack_public_path__ + "static/media/raz-head.3c2a6477.png";